module.exports = __webpack_public_path__ + "img/chf.6462282f.svg";